import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type_work",
  "use": "icon-type_work-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-type_work\"><path d=\"M887 428.5h-76.584a299.128 299.128 0 0 1-88.477 183.274C858.844 684.743 953.315 826.852 958.744 991.5H65.256c5.43-164.648 99.9-306.757 236.805-379.726A299.128 299.128 0 0 1 213.584 428.5H138a30 30 0 0 1 0-60h75.4C227.042 226.3 339.939 113.1 482 98.993V62.5a30 30 0 1 1 60 0v36.493C684.061 113.1 796.958 226.3 810.6 368.5H887a30 30 0 0 1 0 60z m-754.731 503h759.462C867.218 806.682 782.7 703.386 669.458 652.884a300.157 300.157 0 0 1-314.916 0C241.3 703.386 156.782 806.682 132.269 931.5zM512 637.5c122.043 0 222.8-91.1 238.011-209H273.989C289.2 546.4 389.957 637.5 512 637.5z m-238.251-269H482V159.371c-108.889 13.581-195.117 100.1-208.251 209.129zM542 159.371V368.5h208.251C737.117 259.471 650.889 172.952 542 159.371z\" p-id=\"13647\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/type_work.svg
// module id = LYwv
// module chunks = 250